import { gql } from 'apollo-boost';

export default gql`
  mutation validateDriverOtp($input: ValidateDriverOTPInput!){
      validateDriverOtp(input: $input)
  }
`;
